import { render, staticRenderFns } from "./OnlineShop.vue?vue&type=template&id=915d8d9c&scoped=true&"
import script from "./OnlineShop.vue?vue&type=script&lang=js&"
export * from "./OnlineShop.vue?vue&type=script&lang=js&"
import style0 from "./OnlineShop.vue?vue&type=style&index=0&id=915d8d9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "915d8d9c",
  null
  
)

export default component.exports